import AuthLayout from './AuthLayout';
import { Form, Input, message } from 'antd';
import SubmitBtn from './SubmitBtn';
import { useLocation, useNavigate } from 'react-router-dom';
import useSignIn from '../../_hooks/useSignIn';
import useUserSignUp from '../../_hooks/useUserSignUp';
import useUserSession from '../../_hooks/useUserSession';
import { observer } from 'mobx-react-lite';
import { getIdToken } from '../../utils/getIdToken';
import { useAuth } from 'react-oidc-context';
import { FcGoogle } from 'react-icons/fc';
import { getCallbackUri, SERVER_BASE_URL } from '../../__common/env';

const Login = observer(() => {
    return (
        <div>
            <AuthLayout
                title="Login"
                subtitle="Welcome back!"
                content={<LogInForm />}
            />
        </div>
    );
});
export default Login;
export const LogInForm = observer(() => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const auth = useAuth();
    const { state } = useLocation();
    const { handleSignIn, isLoading } = useSignIn();
    const { resendVerificationCode } = useUserSignUp();
    const { checkAuth } = useUserSession();
    const getUser = async () => {
        const token = await getIdToken();

        const response = await fetch(`${SERVER_BASE_URL}/user/profile`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
    };

    const onFinish = (values) => {
        const email = values.email.toLowerCase();
        const password = values.password;
        handleSignIn(email, password)
            .then(() => {
                checkAuth();
                getUser();
                message.success('Login successfully');
                navigate('/');
            })
            .catch((error) => {
                if (error.code === 'UserNotConfirmedException') {
                    message.error(
                        'Please verify your email before logging in.',
                    );
                    navigate('/auth/verify-email', { state: { email } });
                    resendVerificationCode(email)
                        .then(() => {})
                        .catch((err) => {
                            message.error(err.message);
                        });
                    return;
                }
                message.error(error.message);
            });
    };

    return (
        <>
            <Form
                form={form}
                name="login"
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
                autoComplete="off"
                className="auth-form-antd">
                {/* Email */}
                <Form.Item
                    name="email"
                    label="Email *"
                    className="mb-[16px]"
                    rules={[
                        {
                            required: true,
                            type: 'email',
                            message: 'Please enter a  email address!',
                        },
                    ]}>
                    <Input
                        placeholder="Enter your email address"
                        className="auth-form-antd-form-item"
                        autoComplete="username"
                    />
                </Form.Item>
                {/* Password */}
                <Form.Item
                    className="mb-[16px]"
                    name="password"
                    label="Password *"
                    rules={[
                        {
                            required: true,
                            message: 'Please enter your password!',
                        },
                    ]}>
                    <Input.Password
                        placeholder="Enter your password"
                        className="auth-form-antd-form-item"
                        autoComplete="current-password"
                    />
                </Form.Item>
                {/* Forgot Password Link */}
                <div className="font-favorit text-[14px] text-[#5B5F5D]  w-full text-right underline cursor-pointer mb-[16px]">
                    <span onClick={() => navigate('/auth/forgot-password')}>
                        Forgot Password?
                    </span>
                </div>
                {/* Submit Button */}
                <Form.Item className="mb-[16px]">
                    <SubmitBtn
                        label="Sign In"
                        className="w-full"
                        isLoading={isLoading}
                    />
                </Form.Item>{' '}
            </Form>

            {/* Divider */}
            <div className="flex items-center mt-4">
                <div className="flex-1 border-t border-gray-300"></div>
                <span className="mx-3 text-gray-500 text-sm">OR</span>
                <div className="flex-1 border-t border-gray-300"></div>
            </div>

            {/* Google Sign-In Button */}
            <SubmitBtn
                label="Sign In with Google"
                className="w-full google-btn"
                onClick={() => {
                    const callbackUri = getCallbackUri();
                    auth.signinRedirect({
                        redirect_uri: callbackUri,
                        state: JSON.stringify({
                            redirectUrl: '/',
                        }),
                        scope: 'openid profile email',
                        prompt: 'select_account',
                    });
                }}
                disabled={false}
                icon={FcGoogle}
            />

            {/* <div className="font-favorit text-[14px] w-full text-center text-[#5B5F5D]">
                Do not have an account? please{' '}
                <span
                    className="text-theme-orange cursor-pointer hover:underline"
                    onClick={() => navigate('/auth/register')}>
                    Sign Up
                </span>{' '}
            </div> */}
        </>
    );
});
